const CUBOID_VERTEX_TYPE = ({
  FINAL_TOP_LEFT: 'FINAL_TOP_LEFT',
  FINAL_TOP_RIGHT: 'FINAL_TOP_RIGHT',
  FINAL_BOTTOM_RIGHT: 'FINAL_BOTTOM_RIGHT',
  FINAL_BOTTOM_LEFT: 'FINAL_BOTTOM_LEFT',
  INITIAL_TOP_LEFT: 'INITIAL_TOP_LEFT',
  INITIAL_TOP_RIGHT: 'INITIAL_TOP_RIGHT',
  INITIAL_BOTTOM_RIGHT: 'INITIAL_BOTTOM_RIGHT',
  INITIAL_BOTTOM_LEFT: 'INITIAL_BOTTOM_LEFT',
  LEFT_SIDE_TOP: 'LEFT_SIDE_TOP',
  LEFT_SIDE_BOTTOM: 'LEFT_SIDE_BOTTOM',
  RIGHT_SIDE_TOP: 'RIGHT_SIDE_TOP',
  RIGHT_SIDE_BOTTOM: 'RIGHT_SIDE_BOTTOM',
  INITIAL: 'INITIAL',
  FINAL: 'FINAL'
} as const);
const CUBOID_VERTEX_RESIZE_CURSOR = Object.freeze({
  FINAL_TOP_LEFT: 'nwse-resize',
  FINAL_TOP_RIGHT: 'nesw-resize',
  FINAL_BOTTOM_RIGHT: 'nwse-resize',
  FINAL_BOTTOM_LEFT: 'nesw-resize',
  INITIAL_TOP_LEFT: 'nwse-resize',
  INITIAL_TOP_RIGHT: 'nesw-resize',
  INITIAL_BOTTOM_RIGHT: 'nwse-resize',
  INITIAL_BOTTOM_LEFT: 'nesw-resize',
  LEFT_SIDE_TOP: 'ns-resize',
  LEFT_SIDE_BOTTOM: 'ns-resize',
  RIGHT_SIDE_TOP: 'ns-resize',
  RIGHT_SIDE_BOTTOM: 'ns-resize',
  INITIAL: 'move',
  FINAL: 'move'
});
export const VERTEX_TYPE = ({
  TOP_LEFT: 'TOP_LEFT',
  TOP: 'TOP',
  TOP_RIGHT: 'TOP_RIGHT',
  RIGHT: 'RIGHT',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT',
  BOTTOM: 'BOTTOM',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  LEFT: 'LEFT',
  MOVE: 'MOVE',
  ROTATE: 'ROTATE',
  SCALE_TOP_LEFT: 'SCALE_TOP_LEFT',
  SCALE_TOP_CENTER: 'SCALE_TOP_CENTER',
  SCALE_TOP_RIGHT: 'SCALE_TOP_RIGHT',
  SCALE_CENTER_RIGHT: 'SCALE_CENTER_RIGHT',
  SCALE_BOTTOM_RIGHT: 'SCALE_BOTTOM_RIGHT',
  SCALE_BOTTOM_CENTER: 'SCALE_BOTTOM_CENTER',
  SCALE_BOTTOM_LEFT: 'SCALE_BOTTOM_LEFT',
  SCALE_CENTER_LEFT: 'SCALE_CENTER_LEFT',
  ...CUBOID_VERTEX_TYPE
} as const);
export const VERTEX_RESIZE_CURSOR = Object.freeze({
  TOP_LEFT: 'nwse-resize',
  TOP: 'ns-resize',
  TOP_RIGHT: 'nesw-resize',
  RIGHT: 'ew-resize',
  BOTTOM_RIGHT: 'nwse-resize',
  BOTTOM: 'ns-resize',
  BOTTOM_LEFT: 'nesw-resize',
  LEFT: 'ew-resize',
  MOVE: 'move',
  ROTATE: 'alias',
  SCALE_TOP_LEFT: 'nwse-resize',
  SCALE_TOP_CENTER: 'ns-resize',
  SCALE_TOP_RIGHT: 'nesw-resize',
  SCALE_CENTER_RIGHT: 'ew-resize',
  SCALE_BOTTOM_RIGHT: 'nwse-resize',
  SCALE_BOTTOM_CENTER: 'ns-resize',
  SCALE_BOTTOM_LEFT: 'nesw-resize',
  SCALE_CENTER_LEFT: 'ew-resize',
  ...CUBOID_VERTEX_RESIZE_CURSOR
});
export const VERTEX_RADIUS = 4;